import { bootstrapApplication } from '@angular/platform-browser';
import { enableProfiling } from '@angular/core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  console.log = () => {};
  console.info = () => {};
}

// Habilitar profiler solo en desarrollo
if (!environment.production) {
  enableProfiling();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
